module.exports = __webpack_public_path__ + "static/media/of-the-day-blue.77ad82ae.png";